function getScrollbarWidth() {
  // Using document.documentElement is often more accurate for scrollbars than body
  return window.innerWidth - document.documentElement.clientWidth;
}

function updateWidths() {
  const scrollbarWidth = getScrollbarWidth();
  document.body.style.setProperty("--scrollbarWidth", `${scrollbarWidth}px`);
  document.body.style.setProperty(
    "--viewportWidth",
    `calc(100vw - ${scrollbarWidth}px)`,
  );
}

const MIN_DISPLAY_MS = 350;  // prevent flash on fast/cached loads
const MAX_DISPLAY_MS = 5000; // safety ceiling if a resource hangs

let pageLoaded = false;
let minTimeElapsed = false;
let loaderHidden = false;

function hideLoader() {
  if (!pageLoaded || !minTimeElapsed || loaderHidden) return;
  loaderHidden = true;
  const loader = document.getElementById("preloader");
  if (loader) loader.classList.add("loader-hidden");
  updateWidths();
}

// Minimum display timer — whichever is later (this or page load) wins
setTimeout(() => {
  minTimeElapsed = true;
  hideLoader();
}, MIN_DISPLAY_MS);

// Safety fallback — hide unconditionally if resources stall beyond ceiling
setTimeout(() => {
  pageLoaded = true;
  minTimeElapsed = true;
  hideLoader();
}, MAX_DISPLAY_MS);

function onPageLoaded() {
  pageLoaded = true;
  hideLoader();
}

// Fast-path: all resources already loaded before this script ran
// (common with fast Shopify servers/caching)
if (document.readyState === "complete") {
  onPageLoaded();
} else {
  window.addEventListener("load", onPageLoaded);
}

window.addEventListener("resize", updateWidths);
